import { AppStatus } from "@bprotsyk/aso-core";

export const emptyAppState = {
    id: 0,
    name: "",
    bundle: "",
    enabled: true, // Always enabled by default
    appmetricaApiKey: "",
    appmetricaAppId: 0,
    status: AppStatus.IN_DEVELOPMENT,
    keitaroData: false,
    bannerParams: null,
    offersStubParams: {
      offersPath: "",
      imagesPath: ""
    },
    domainParams: {
      name: ""
    },
    platforms: {
        "@": {
            enabled: true,
            params: null,
            keitaroData: true,
            newPlatform: true,
            appsflyerParams: {apiToken: ""},
        direct: {
            enabled: false,
            keitaroData: false,
            directType: "keitaroOffer",
            }
        }
    },
    ech: false,
    file: null,
  };